var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineRam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 22.75c-3.71 0-5.75-2.04-5.75-5.75V7c0-3.71 2.04-5.75 5.75-5.75h7c3.65 0 5.75 2.1 5.75 5.75v1c0 .96-.79 1.75-1.75 1.75-.14 0-.25.11-.25.25v2.17c0 .33.13.65.37.88l.83.83c.52.52.81 1.21.81 1.94V17c-.01 3.65-2.11 5.75-5.76 5.75h-7zM4.25 7v10c0 2.86 1.39 4.25 4.25 4.25h7c2.82 0 4.25-1.43 4.25-4.25v-1.17c0-.33-.13-.65-.37-.88l-.83-.83c-.52-.52-.81-1.21-.81-1.94V10c0-.96.79-1.75 1.75-1.75.14 0 .25-.11.25-.25V7c0-2.82-1.43-4.25-4.25-4.25H8.5C5.64 2.75 4.25 4.14 4.25 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.26 21.98-.03-2.99c0-.69-.57-1.24-1.25-1.24h-4A1.249 1.249 0 0 0 8.73 19l.01 2.97a.749.749 0 1 1-1.5 0L7.23 19c0-.74.28-1.43.8-1.95s1.21-.81 1.95-.81h4.01c1.51 0 2.74 1.23 2.75 2.73l.03 2.98c0 .43-.34.77-.76.77.007 0 .007 0 0 0-.41 0-.75-.33-.75-.74zM7.97 8.53c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6a.749.749 0 1 1 0 1.5h-6z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRam);
export default __webpack_public_path__ + "static/media/vuesax-outline-ram.9db7047aca5f2e787106986e12c2fd95.svg";
export { ForwardRef as ReactComponent };